import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class TimeoutWarningState {

    private millisesondsLeftSource = new ReplaySubject<number>(1);

    public get millisecondsLeft() {
        return this.millisesondsLeftSource.asObservable();
    }

    public setMillisecondsLeft(milliseconds: number) {
        this.millisesondsLeftSource.next(milliseconds);
    }
}